var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCheckmarkPlain = function SvgCheckmarkPlain(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.721 1.961a.952.952 0 0 0-1.346 0L4.317 8.02 1.625 5.327A.952.952 0 1 0 .279 6.673l3.365 3.366a.949.949 0 0 0 1.346 0l6.731-6.731a.952.952 0 0 0 0-1.347Z"
  })));
};

export default SvgCheckmarkPlain;